var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('apexchart',{attrs:{"width":"100%","height":"400","type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }